/* eslint camelcase: 0 */
/* global ADB, s_pageview_id, s_md, wmdSetContext, remLinkTrackVars, addLinkTrackVars, wmdPageLink */
import HBT                           from 'heartbeat';
import { defaults, camelCase,
        keys, assign, extend, get }  from '_';
import { envCheck, isMobile, isIOS, isIpad } from 'utils/util';
import Reflux                        from 'reflux';
import HasMedscapeGlobals            from 'mixins/has_medscape_globals';
import HasPrettyTime                 from 'mixins/has_pretty_time';
import VideoStore                    from 'stores/video_store';
import $                             from 'jquery';
import BPTracking                    from 'mixins/bp_tracking';
import DescriptorStore               from 'stores/descriptor_store';
import md5                           from 'md5';

export default Reflux.createStore({
  mixins: [ HasMedscapeGlobals, HasPrettyTime],
  isFirstPlay: true,
  isWaiting: false,
  hasStarted: false,
  hasEnded: false,
  init() {
    this.tracking = window.bpInstance.hasOwnProperty('tracking') ? window.bpInstance.tracking : null;
    window.s_sact = this.tracking.sfNumber;
    window.s_sptr = `${this.tracking.brandName} [ ${this.tracking.brandId} ]`;
    window.s_sprodid = this.tracking.productId;
    window.s_sprod = this.tracking.productName;
    window.s_sactid = this.tracking.cp.activityId;
    window.s_spcrtid = this.tracking.partnerCreativeID;
    this.contextDataVars = [
      'contextData.a.contentType',
      'contextData.a.media.name',
      'contextData.a.media.playerName',
      'contextData.a.media.pageName',
      'contextData.a.media.friendlyName',
      'contextData.a.media.length',
      'contextData.a.media.channel',
      'contextData.a.media.view',
      'contextData.a.media.ad.name',
      'contextData.a.media.ad.podFriendlyName',
      'contextData.a.media.ad.length',
      'contextData.a.media.ad.pod',
      'contextData.a.media.ad.podPosition',
      'contextData.a.media.ad.podSecond',
      'contextData.a.media.ad.CPM',
      'contextData.a.media.ad.view',
      'contextData.a.media.extcampaign',
      'contextData.wb.vpgnm',
      'contextData.wb.ecd',
      'contextData.wb.sptr',
      'contextData.wb.sprodid',
      'contextData.wb.sprod',
      'contextData.wb.sactid',
      'contextData.wb.sact',
      'contextData.wb.asset',
      'contextData.vpgnm',
      'contextData.ecd',
      'contextData.chn',
      'contextData.rs',
      'contextData.site',
      'contextData.dprofsn',
      'contextData.dspclty',
      'contextData.regid',
      'contextData.dcntry',
      'contextData.vpagename'
    ];
    this.initMedscapeGlobals();
    this.isCPDisabled   = (typeof this.cp === 'undefined') ? true: false;
    this.isIPPDisabled  = false;
    this.$metrics.prop6 = 'video-brandplay';
    this.mmodule = 'video-brandplay';
    this.listenTo(VideoStore, this.onVideoChange.bind(this));
    window.trackingEnabled = true;
    this.Bptracking = new BPTracking();
    this.addHeartbeatContext();
    this.playerEle = null;
    this.playList = null;
    this.playerStatus = {};
    addLinkTrackVars('contextData.wb.spcrtid');
    // set 3rd party tracking listener, triggered on: progress, play, pause, mute, unmute, start, fullscreen, collapse
    $(window)
        .on('track:3rdParty', (event, obj) => {
          if(this.getTrackURL() !== undefined) {
            this.Bptracking.thirdPartyTracking(this.getTrackURL(), obj.ev, obj.param);
          }
        })
        .on('onSetCaption', this.onSetClosedCaptioning);
    this.isVideoRendered();
  },
  isVideoRendered() {
      if(isMobile) {
        if(!$('video')[0]) {
          window.requestAnimationFrame(this.isVideoRendered);
        } else {
          this.setMobileTrackHandlers();
        }
      }
      if(!isMobile && $('.playlist').length > 0) {
          window.requestAnimationFrame(this.isVideoRendered);
      } else {
          this.playList = $('.playlist');
      }
  },
  setMobileTrackHandlers() {
    this.playerEle = VideoStore.mediaApi._v.getMediaElement();
    this.playerEle.addEventListener('volumechange', () => {
          this.playerStatus.currentVolume = this.playerEle.muted ? 0 : this.playerEle.volume;
          this.onVolumeChanged(this.playerStatus);
    });
    // listen to native player event 'change' to track closed captioning
    this.playerEle.textTracks.addEventListener('change', (e)=> {
      const useCC = {};
      if(e.target[0].mode) {
        const track =  e.target[0];
        if(track.mode !== 'hidden') {
          track.mode == 'showing' ? useCC.on = true : useCC.on = false;
            this.onSetClosedCaptioning(e, useCC);
        }
      }
    });
    const prefix = 'vidvbp-ctl_';
    const eventMap = [
        {event: 'play', prop : prefix + 'play'},
        {event: 'pause', prop : prefix + 'pause'},
        {event: 'seeked', prop : prefix + 'scrub'},
        {event: 'volumechange', eventName: true, prop: () => { return prefix + (this.playerEle.muted ? 'muted': 'unmuted');}},
        {event: 'webkitfullscreenchange', eventName: true, prop: () => { return prefix + (document.webkitFullscreenElement? 'fullscreen' : 'collapsed');}}
    ].forEach((obj, i, arr) => {
        this.playerEle.addEventListener(obj.event, this.mobile3rdPartyHandler.bind(null, arr[i], prefix));
    });
    if(isMobile()) {
      if(isIOS()) {
        $('video.akamai-html5').on('webkitbeginfullscreen',(e)=>{
          let articleNo = this.getArticleNo();
          this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_bigr');
        });
        $('video.akamai-html5').on('webkitendfullscreen',(e)=>{
          let articleNo = this.getArticleNo();
          this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_smalr');
        });
      } else {
        $('video.akamai-html5').on('webkitfullscreenchange',(e)=>{
          if(document.webkitFullscreenElement === null) {
            let articleNo = this.getArticleNo();
            this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_smalr');
          } else {
            let articleNo = this.getArticleNo();
            this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_bigr');
          }
        });
      }
    }
  },
  mobile3rdPartyHandler(mobileEvent, prefix, event) {
    // convert event name before tracking if volume or fullscreen
    const key = mobileEvent.eventName ? mobileEvent.prop().substr(prefix.length) : mobileEvent.event;
    const val = (typeof mobileEvent.prop === 'function' ? mobileEvent.prop() : mobileEvent.prop);
    $(window).trigger('track:3rdParty', {ev: key, param: val});
  },
  trackingPixelRequest(trackingPixel) {
    if(trackingPixel && trackingPixel !== '') {
      const pixelImg = document.createElement('img');
      pixelImg.style.opacity = 0;
      pixelImg.src = trackingPixel;
      document.body.appendChild(pixelImg);
    }
  },
  resetDurationTracking() {
    this.percentages = { [25]: true, [50]: true, [75]: true, [100]: true };
  },
  onVideoChange(state) {
    const { event } = state.video,
            handler = camelCase(`on_${event}`);
    if(this[handler]) {
      this[handler](state.video);
    }
  },
  onseeked(){
  },
  onBuffering(){
  },
  onVideoSelected() {
    if(!this.isFirstPlay && this.heartbeat) {
        if(this.analyticsPlugin) {
          this.analyticsPlugin.setAdMetadata(null);
          this.analyticsPlugin.setVideoMetadata(null);
        }
        if(this.VideoPlayerPlugin) {
          this.VideoPlayerPlugin.trackVideoUnload();
          this.heartbeat.destroy();
        }
        this.hasStarted = false;
        this.hasEnded = false;
    }
    this.isFirstPlay = false;
  },
  onPlay(state) {
    const isStart = !this.hasStarted && !this.hasEnded;
    let articleNo = this.getArticleNo();
    // hasStarted is set only once on the first play. Once it's true it remains that way
    // hasEnded is reset to `false` at the beginning of every play and set to `true` onEnded.
    //
    // This allows us to trigger the appropriate call on the first play (e.g. replay or play)
    // But handle video replays as well.
    if(isStart) {
      if(isIpad()) {
        if(state.meta.autoplay === true && this.isFirstPlay === true) {
          $('.chapter-link-in-menu').removeClass('now_playing_color');
          $('#chapter-'+articleNo).addClass('now_playing_color');
        }
      }
      if(this.isFirstPlay){
        this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_play');
      }
      $(window).trigger('track:3rdParty', {ev: 'start', param: 'vidvbp-ctl_start'});
      this.trackingPixelRequest(state.meta.video0);
      this.initHeartbeat();
      this.VideoPlayerPlugin.trackVideoLoad();
      this.cp.appname = 'ippevent';
      this.cp.activityName = 'participation';
      window.postCp(this.cp);
      this.Bptracking.trackIpp('startPresentation');
      this.isFirstPlay = false;
      this.VideoPlayerPlugin.trackSessionStart();
      this.addHeartbeatContext();
      if(isStart) {

        this.VideoPlayerPlugin.trackVideoLoad();
        this.VideoPlayerPlugin.trackSessionStart();
        this.remHeartbeatContext();
      }
      if(this.analyticsPlugin) {
        this.analyticsPlugin.setVideoMetadata({
                   chn: 'test',
                    rs: s_md.prop50 || '',
                  site: 'brandplay',
               dprofsn: s_md.prop19 || '',
               dspclty: s_md.prop38 || '',
                 regid: s_md.prop47 || '',
                dcntry: s_md.prop37 || '',
              pageName: s_md.eVar1  || this.articleId,
           extcampaign: (typeof s_md.contextData['wb.ecd'] !== 'undefined')?s_md.contextData['wb.ecd'] :'',
                  sptr: `${this.tracking.brandName} [ ${this.tracking.brandId} ]`,
               sprodid: this.tracking.productId,
                 sprod: this.tracking.productName,
                sactid: this.tracking.cp.activityId,
                  sact: `sf${this.tracking.sfNumber}`,
                 asset: this.mmodule,
               spcrtid: this.tracking.partnerCreativeID
        });
      }
      this.hasStarted = true;
      this.hasEnded   = false;
      this.remHeartbeatContext();
      let articleNo = this.getArticleNo();
      this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp_start');
      this.cp.appname = 'ippcontent';
      this.cp.activityName = 'scn' + articleNo;
      window.postCp(this.cp);
      this.resetDurationTracking();
      $('.chapter-link-in-menu').removeClass("now_playing_color");
      $('#chapter-'+articleNo).addClass("now_playing_color");
      this.resetDurationTracking();
    }
    this.VideoPlayerPlugin.trackPlay();
  },
  onStarted() {
  },
  onProgress(state) {
    if(get(this, 'playerEle.currentTime', null) !== null) {
      const trackPrefix = 'vidvbp_';
      const percent = Math.round( (this.playerEle.currentTime / this.playerEle.duration) * 100);
      let articleNo = this.getArticleNo();
      if(this.hasStarted && !state.isEnded) {
        [25, 50, 75].forEach((i) => {
          if (percent > i && this.percentages[i]) {
            this.percentages[i] = false;
            this.Bptracking.pamTrack('ARTICLE-'+articleNo, trackPrefix + `${i}pct`, this);
            if(i == 25) this.trackingPixelRequest(state.meta.video25);
            if(i == 50) this.trackingPixelRequest(state.meta.video50);
            if(i == 75) this.trackingPixelRequest(state.meta.video75);
            $(window).trigger('track:3rdParty', {ev: 'progress', param: trackPrefix + i + '%'});
          }
        });
      }
      if(state.hasStarted && !percent > 0) $(window).trigger('track:3rdParty', {ev: 'progress', param: trackPrefix + 0 + '%'});
    }
  },
  onEnded(state) {
    if(this.hasEnded !== true) {
      let articleNo = this.getArticleNo();
      this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp_100pct', this);
      this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'allvideo_100pct');
      $(window).trigger('track:3rdParty', {ev: 'progress', param: 'vidvbp_100%'});
      this.analyticsPlugin.setAdMetadata(null);
      this.analyticsPlugin.setVideoMetadata(null);
      this.VideoPlayerPlugin.trackComplete();
      this.VideoPlayerPlugin.trackVideoUnload();
      this.hasEnded = true;
      this.resetDurationTracking();
      this.trackingPixelRequest(state.meta.video100);
    }
    window.trackingEnabled = false;
  },
  onSettingTime() {
    let articleNo = this.getArticleNo();
        this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_scrb'); // desktop scrub
        // removing 3rdParty tracking from this event, as it fires on play / start, already handled in setMobileTrackHandlers()
  },
  onVolumeChanged(state) {
    if(isIpad() && this.prevVolume === undefined) {
      this.prevVolume = state.currentVolume;
      return;
    }
    const { currentVolume } = state;
    let articleNo = this.getArticleNo();
    if(this.prevVolume !== currentVolume) {
      if(currentVolume === 0) {
        this.isMuted = true;
        this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_mute');
        $(window).trigger('track:3rdParty', {ev: 'mute', article: articleNo, param: 'vidvbp-ctl_mute'});
      } else if(this.isMuted) {
        this.isMuted = false;
        this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_mutex');
        $(window).trigger('track:3rdParty', {ev: 'unmute', article: articleNo, param: 'vidvbp-ctl_mutex'});
      } else {
        if(isIpad()) {
          this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_mutex');
        }
        this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_vol');
      }
    }
    this.prevVolume = currentVolume;
  },
  onFullScreen() {
    if(!this.isFullScreen) {
      this.isFullScreen = true;
      let articleNo = this.getArticleNo();
      this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_bigr');
      $(window).trigger('track:3rdParty', {ev: 'expand', article: articleNo, param: 'vidvbp-ctl_bigr'});
    }
  },
  onExitFullScreen() {
    if(this.isFullScreen) {
      this.isFullScreen = false;
      let articleNo = this.getArticleNo();
      this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_smalr');
      $(window).trigger('track:3rdParty', {ev: 'collapse', article: articleNo, param: 'vidvbp-ctl_smalr'});
    }
  },
  onSetClosedCaptioning(e, isSet) {
    let captionText = isSet.on ? 'ccy':'ccn',
        articleNo = this.getArticleNo();
    this.Bptracking.pamTrack('ARTICLE-'+articleNo, `vidvbp-ctl_${captionText}`);
  },
  initHeartbeat() {
    if(typeof HBT.ADB === 'undefined' || typeof s_md === 'undefined') { // eslint-disable-line
      return;
    }
    // Map values to make code readable;
    const { plugins, HeartbeatDelegate, HeartbeatConfig, Heartbeat } = HBT.ADB.va,
          { AdobeAnalyticsPluginConfig, AdobeAnalyticsPluginDelegate, AdobeAnalyticsPlugin } = plugins.aa,
          { AdobeHeartbeatPluginConfig, AdobeHeartbeatPluginDelegate, AdobeHeartbeatPlugin } = plugins.ah,
          { VideoPlayerPluginConfig, VideoPlayerPluginDelegate, VideoPlayerPlugin, VideoInfo, ChapterInfo } = plugins.videoplayer;

    const analyticsPluginConfig     = new AdobeAnalyticsPluginConfig(),
          analyticsPluginDelegate   = new AdobeAnalyticsPluginDelegate(),
          analyticsPlugin           = new AdobeAnalyticsPlugin(s_md, analyticsPluginDelegate), // eslint-disable-line

          heartbeatPluginConfig     = new AdobeHeartbeatPluginConfig(document.location.protocol + '//webmd.hb.omtrdc.net', '16AD4362526701720A490D45@AdobeOrg'),
          heartbeatPluginDelegate   = new AdobeHeartbeatPluginDelegate(),
          heartbeatPlugin           = new AdobeHeartbeatPlugin(heartbeatPluginDelegate),

          heartbeatConfig           = new HeartbeatConfig(),
          heartbeatDelegate         = new HeartbeatDelegate(),

          videoPlayerPluginConfig   = new VideoPlayerPluginConfig(),
          videoPlayerPluginDelegate = new VideoPlayerPluginDelegate(); // VideoStore.mediaApi._v.getMediaElement()
          this.VideoPlayerPlugin    = new VideoPlayerPlugin(videoPlayerPluginDelegate);

          this.analyticsPlugin            = analyticsPlugin;
          this.videoPlayerPluginDelegate  = videoPlayerPluginDelegate;

          analyticsPluginConfig.channel   = this.$metrics.prop47;
          heartbeatPluginConfig.sdk       = 'Heartbeats V-1.5.4';
          heartbeatPluginConfig.ssl       = (document.location.protocol === 'https:');

    this.addHeartbeatContext();
    analyticsPluginConfig.debugLogging   = false;
    heartbeatPluginConfig.debugLogging   = false;
    heartbeatConfig.debugLogging         = false;
    videoPlayerPluginConfig.debugLogging = false;
    heartbeatPluginConfig.quietMode      = false;
    const preHashValue = `${this.ipp.sfNum}_ARTICLE-${this.getArticleNo()}`;
    const hashValue = md5(preHashValue);
    videoPlayerPluginDelegate.getVideoInfo = () => {
      const info              = new VideoInfo;
            info.id           = `video_${this.ipp.sfNum}_${this.getArticleNo()}`;
            info.name         = `video${this.getArticleNo()}`;
            info.playerName   = `coreLibVideo-${hashValue}`;
            info.length       = VideoStore.getDuration();
            info.streamType   = 'vod';
            info.playhead     = VideoStore.getCurrentTime() || 0;
            info.friendlyName = `video_${this.getArticleNo()}`;
      return info;
    };

    videoPlayerPluginDelegate.getChapterInfo = () => {
      const info     = new ChapterInfo();
      info.name      = `video ${this.getArticleNo()}`;
      info.length    = VideoStore.getDuration();
      info.position  = VideoStore.getCurrentTime();
      info.startTime = 0;
      return info;
    };

    // configure  plugins
    heartbeatPlugin.configure(heartbeatPluginConfig);
    analyticsPlugin.configure(analyticsPluginConfig);
    this.VideoPlayerPlugin.configure(videoPlayerPluginConfig);
    this.heartbeat = new Heartbeat(heartbeatDelegate, [this.VideoPlayerPlugin, analyticsPlugin, heartbeatPlugin]);
    this.heartbeat.configure(heartbeatConfig);

    $(window).on('beforeunload', () => {
      this.VideoPlayerPlugin.trackVideoUnload();
      this.VideoPlayerPlugin.destroy();
    });

    // Not heartbeat, this is used to track pause and play of the video through omniture.
    $(VideoStore.mediaApi._v.getMediaElement()).unbind('pause').bind('pause', ()=> {
        let  articleNo = this.getArticleNo();
        let  trackURL = '',
             theIndex = VideoStore.getIndex();
             trackURL = DescriptorStore.getVideos()[theIndex].trackingURL;

        this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_pause');
    });
    $(VideoStore.mediaApi._v.getMediaElement()).unbind('play').bind('play', ()=> {
      let articleNo = this.getArticleNo();
        this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_play');
        $('.chapter-link-in-menu').removeClass("now_playing_color");
        $('#chapter-'+articleNo).addClass("now_playing_color");
    });
    if(isMobile) {
      $(VideoStore.mediaApi._v.getMediaElement()).unbind('seeked').bind('seeked', ()=> {
        let articleNo = this.getArticleNo();
          this.Bptracking.pamTrack('ARTICLE-'+articleNo, 'vidvbp-ctl_scrb');
      });
    }
  },
  getArticleNo() {
    /*
     * conditional used to return 1 for programs with only 1 video
     * */
     return  (bpInstance.videos.length !== 1) ? VideoStore.getIndex()+1 : 1;
  },
  getTrackURL() {
    return DescriptorStore.getVideos()[VideoStore.getIndex()].trackingURL;
  },
  addHeartbeatContext() {
    if(typeof addLinkTrackVars === 'undefined') {
      return;
    } else {
      addLinkTrackVars(this.contextDataVars.toString());
      //addLinkTrackVars('contextData.wb.spcrtid');
      window.wmdSetContext('wb.sprod', this.tracking.productName);
      window.wmdSetContext('wb.sactid', this.tracking.cp.activityId);
      window.wmdSetContext('wb.sact', `sf${this.tracking.sfNumber}`);
      window.wmdSetContext('wb.spcrtid', this.tracking.partnerCreativeID);
    }
  },
  remHeartbeatContext() {
    if(typeof addLinkTrackVars === 'undefined') {
      return;
    } else {
      remLinkTrackVars(this.contextDataVars.toString());
    }
  }
});



// WEBPACK FOOTER //
// ./modules/stores/brand_play_tracking_store.js